import { render, staticRenderFns } from "./GiftGuide.vue?vue&type=template&id=5d92a7dc&"
import script from "./GiftGuide.vue?vue&type=script&lang=js&"
export * from "./GiftGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports